import { render, staticRenderFns } from "./TalentDetailsCard.htm?vue&type=template&id=4c0b4024&scoped=true&"
import script from "./TalentDetailsCard.ts?vue&type=script&lang=js&"
export * from "./TalentDetailsCard.ts?vue&type=script&lang=js&"
import style0 from "./TalentDetailsCard.scss?vue&type=style&index=0&id=4c0b4024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b4024",
  null
  
)

export default component.exports